<div class="form-field">
  <span class="form-field__label">{{ label }}</span>
  @if (!isTextArea) {
    <app-az-input
      [value]="value"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [type]="type"
      (valueChange)="onValueChange($event)"
    />
  }
  @if (isTextArea) {
    <textarea
      class="form-field__textarea"
      [value]="value"
      [placeholder]="placeholder"
      [disabled]="disabled"
      (input)="onValueChange($any($event.target).value)"
    ></textarea>
  }
</div>
